export const mint = {
  1: { value: { base: '{colors.mint.light.1}', _dark: '{colors.mint.dark.1}' } },
  2: { value: { base: '{colors.mint.light.2}', _dark: '{colors.mint.dark.2}' } },
  3: { value: { base: '{colors.mint.light.3}', _dark: '{colors.mint.dark.3}' } },
  4: { value: { base: '{colors.mint.light.4}', _dark: '{colors.mint.dark.4}' } },
  5: { value: { base: '{colors.mint.light.5}', _dark: '{colors.mint.dark.5}' } },
  6: { value: { base: '{colors.mint.light.6}', _dark: '{colors.mint.dark.6}' } },
  7: { value: { base: '{colors.mint.light.7}', _dark: '{colors.mint.dark.7}' } },
  8: { value: { base: '{colors.mint.light.8}', _dark: '{colors.mint.dark.8}' } },
  9: { value: { base: '{colors.mint.light.9}', _dark: '{colors.mint.dark.9}' } },
  10: { value: { base: '{colors.mint.light.10}', _dark: '{colors.mint.dark.10}' } },
  11: { value: { base: '{colors.mint.light.11}', _dark: '{colors.mint.dark.11}' } },
  12: { value: { base: '{colors.mint.light.12}', _dark: '{colors.mint.dark.12}' } },
  a1: { value: { base: '{colors.mint.light.a1}', _dark: '{colors.mint.dark.a1}' } },
  a2: { value: { base: '{colors.mint.light.a2}', _dark: '{colors.mint.dark.a2}' } },
  a3: { value: { base: '{colors.mint.light.a3}', _dark: '{colors.mint.dark.a3}' } },
  a4: { value: { base: '{colors.mint.light.a4}', _dark: '{colors.mint.dark.a4}' } },
  a5: { value: { base: '{colors.mint.light.a5}', _dark: '{colors.mint.dark.a5}' } },
  a6: { value: { base: '{colors.mint.light.a6}', _dark: '{colors.mint.dark.a6}' } },
  a7: { value: { base: '{colors.mint.light.a7}', _dark: '{colors.mint.dark.a7}' } },
  a8: { value: { base: '{colors.mint.light.a8}', _dark: '{colors.mint.dark.a8}' } },
  a9: { value: { base: '{colors.mint.light.a9}', _dark: '{colors.mint.dark.a9}' } },
  a10: { value: { base: '{colors.mint.light.a10}', _dark: '{colors.mint.dark.a10}' } },
  a11: { value: { base: '{colors.mint.light.a11}', _dark: '{colors.mint.dark.a11}' } },
  a12: { value: { base: '{colors.mint.light.a12}', _dark: '{colors.mint.dark.a12}' } },
}
